<template>
  <Card class="layout-card" style="height: 100%">
    <div style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        flex-shrink: 0;
      ">
      <div class="search-form">
        <Select placeholder="请选择推送类型" v-model="searchForm.channel" clearable style="width: 200px">
          <Option value="0">Push消息</Option>
          <Option value="1">Email邮件</Option>
        </Select>
        <Select placeholder="请选择触发类型" v-model="searchForm.triggerTypeCode" clearable style="width: 200px">
          <Option value="sign">签到</Option>
          <Option value="drama">新剧推送</Option>
          <Option value="offers">付费优惠</Option>
          <Option value="activity">活动提醒</Option>
        </Select>
        <Select placeholder="请选择人群包" v-model="searchForm.crowdPackIds" style="width: 150px" multiple :max-tag-count="1">
          <Option v-for="(item, index) in crowdList" :key="index" :value="item.id">{{ item.name }}</Option>
        </Select>
        <Select placeholder="请选择开启状态" v-model="searchForm.states" style="width: 200px" clearable>
          <Option :value="1">开启</Option>
          <Option :value="0">关闭</Option>
        </Select>
        <DatePicker format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="请选择触发时间" style="width: 200px" @on-change="handleTriggerTimeRangeChange"></DatePicker>
        <Select v-model="searchForm.subscriptionTopicId" placeholder="请选择语言" style="width: 150px" clearable>
          <Option v-for="(item, index) in topicLi" :key="index" :value="item.id">{{ item.dictDesc }}</Option>
        </Select>
      </div>
      <div>
        <Button type="primary" v-if="buttonMenu['/push/add']" @click="handleOpenEditModal()">添加</Button>
      </div>
    </div>
    <div class="search-form" style="margin-bottom: 10px">
      <Input v-model="searchForm.playName" placeholder="请输入短剧名称" style="width: 200px" />
      <Button type="primary" style="margin-left: 10px" @click="getData()">查询</Button>
      <Button @click="handleReset()" style="margin-left: 10px">重置</Button>
    </div>
    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns">
        <template #state="{ row }">
          <div>
            <i-switch v-if="buttonMenu['/push/switch']" :value="!!row.states"
              :before-change="() => handleChangeStatus(row)" @on-change="row.states = $event"></i-switch>
            <span v-else>{{ row.states }}</span>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a style="margin-left: 10px" v-if="buttonMenu['/push/edit']" @click="handleOpenEditModal(row)">编辑</a>
            <a style="margin-left: 10px; color: #ed4014;" @click="handleDel(row)">删除</a>
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>
    <Modal :width="50" v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '推送'">
      <Form ref="formRef" @submit.native.prevent :label-width="100" :model="form"  v-if="editVisible">
        <FormItem label="推送类型：" prop="channel" :rules="[{ required: true, message: '请选择推送类型' }]">
          <Select placeholder="请选择推送类型" v-model="form.channel" @on-change="handleChannelChange">
            <Option :value="0">Push消息</Option>
            <Option :value="1">Email邮件</Option>
          </Select>
        </FormItem>
        <FormItem label="触发类型：" prop="triggerTypeCode" :rules="[{ required: true, message: '请选择触发类型' }]">
          <Select placeholder="请选择触发类型" v-model="form.triggerTypeCode" @on-change="handleTriggerTypeChange">
            <Option value="sign">签到</Option>
            <Option value="drama">新剧推送</Option>
            <Option value="offers">付费优惠</Option>
            <Option value="activity">活动提醒</Option>
          </Select>
        </FormItem>
        <!-- 推送类型：push消息 -->
        <div v-if="form.channel === 0">
          <FormItem label="推送对象：">
            <RadioGroup v-model="form.pushMode" type="button" @on-change="handlePushModeChange">
              <Radio :label="2">主题推送</Radio>
              <Radio :label="0">指定人群</Radio>
            </RadioGroup>
          </FormItem>
          <div v-if="form.pushMode === 2" ref="pushForm">
            <FormItem label="语言：" prop="subscriptionTopicId" :rules="[
              {
                required: true,
                message: '请选择语言'
              }
            ]">
              <Select v-model="form.subscriptionTopicId" placeholder="请选择语言">
                <Option v-for="(item, index) in topicLi" :key="index" :value="item.id">{{ item.dictDesc }}
                </Option>
              </Select>
            </FormItem>
            
          </div>
          <div v-else-if="form.pushMode === 0">
            <FormItem label="人群包：">
              <Select placeholder="请选择人群包" v-model="form.crowdPackIds" clearable multiple>
                <Option v-for="(item, index) in crowdList" :key="index" :value="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="推送用户：">
              <Input v-model="form.multiUserIds" placeholder="请输入用户id,多个id使用英文<,>隔开" />
            </FormItem>
          </div>
          <FormItem label="标题：" prop="pushTitle" :rules="[
              {
                required: true,
                message: '请输入标题'
              }
            ]">
              <Input v-model="form.pushTitle" placeholder="请输入标题" />
            </FormItem>
          <FormItem label="内容：" prop="pushMsg" :rules="[{ required: true, message: '请输入内容' }]">
            <Input placeholder="请输入内容" v-model="form.pushMsg" type="textarea" :autosize="{ minRows: 5 }"
              :maxlength="500" />
          </FormItem>
          <FormItem label="图片：">
            <UploadFileImg :uploadList="form.fileUrl ? [form.fileUrl] : []" v-model="form.fileUrl" :maxSize="100" @hanldDel="
              form.fileId = ''
              form.fileUrl = ''
              " @handleSuccess="
                form = {
                  ...form,
                  fileId: $event.fileId,
                  fileUrl: $event.fileUrl
                }
                ">
            </UploadFileImg>
          </FormItem>
          <FormItem v-if="form.triggerTypeCode === 'activity'" label="跳转H5：" prop="jumpInterface"
            :rules="[{ required: true, message: '请选择跳转H5' }]">
            <Select placeholder="请选择跳转H5" v-model="form.jumpInterface" @on-change="handleJumpInterfaceChange">
              <Option v-for="(item, index) in filteredJumpInterfaceList" :key="index" :value="item.id">{{ item.ruleName }}</Option>
            </Select>
          </FormItem>
          <FormItem v-else label="跳转界面：" prop="jumpInterface" :rules="[{ required: true, message: '请选择跳转界面' }]">
            <Select placeholder="请选择跳转界面" v-model="form.jumpInterface" @on-change="handleJumpPageChange">
              <Option value="0">首页</Option>
              <Option value="1">剧集页</Option>
              <Option value="2">签到活动页</Option>
              <Option value="3">充值页</Option>
              <Option value="4">收藏页</Option>
              <Option value="5">For U页</Option>
            </Select>
          </FormItem>
        </div>
        <!-- 推送类型：email邮件 -->
        <div v-if="form.channel === 1">
          <FormItem label="推送对象：">
            <RadioGroup v-model="form.pushMode" type="button" @on-change="handlePushModeChange">
              <Radio :label="1">不限</Radio>
              <Radio :label="0">指定人群</Radio>
            </RadioGroup>
          </FormItem>
          <template v-if="form.pushMode === 0">
            <FormItem label="人群包：">
              <Select placeholder="请选择人群包" v-model="form.crowdPackIds" clearable multiple>
                <Option v-for="(item, index) in crowdList" :key="index" :value="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="推送用户：">
              <Input v-model="form.multiUserIds" placeholder="请输入用户id,多个id使用英文<,>隔开" />
            </FormItem>
          </template>
          <FormItem label="标题：" prop="emailTitle" :rules="[{ required: true, message: '请输入邮件标题' }]">
            <Input v-model="form.emailTitle" placeholder="请输入邮件标题" />
          </FormItem>
          <div style="border: 1px solid #ccc; margin-bottom: 10px" v-if="form.channel === 1">
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
              :mode="mode" />
            <Editor style="height: 200px; overflow-y: hidden" v-model="form.emailBody" :defaultConfig="editorConfig"
              :mode="mode"  @onCreated="onCreated" />
          </div>
        </div>
        <FormItem v-if="form.jumpInterface === '1'" label="短剧：" prop="playName" :rules="[{ required: true, message: '请输入短剧' }]">
            <AutoComplete
                v-model="form.playName"
                :data="playList"
                :filter-method="() => true"
                @on-search="getPlayList"
                @on-select="handleSelectPlay"
                placeholder="请输入短剧"
            />
        </FormItem>
        <FormItem v-if="form.jumpInterface === '1'" label="剧集：" prop="seriesId" :rules="[{ required: true, message: '请选择剧集' }]">
          <Select placeholder="请选择剧集" v-model="form.seriesId" >
            <Option v-for="(item, index) in seriesList" :key="item.id" :value="item.id">{{ item.seriesName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="触发条件：" prop="triggerTime" :rules="[{ required: true, message: '请输入触发时间' }]">
          <DatePicker type="datetime" :value="form.triggerTime" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择触发时间" style="width: 200px" @on-change="handleTriggerTimeChange"></DatePicker>
        </FormItem>
        <FormItem label="状态：" prop="states" :rules="[{ required: true, message: '请选择状态' }]">
          <i-switch v-model="form.states"></i-switch>
        </FormItem>

      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
      </template>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import UploadFileImg from '@/components/Upload/uploadImg.vue'
import { debounce } from 'lodash'
import { getDictionaryList } from '@/api/dictionary'
import { getCrowdList } from '@/api/crowd'
import {
  getPushList,
  addPush,
  editPush,
  getPushInfo,
  changePushStatus,
  delPush
} from '@/api/push'
import { getSeriesList } from '@/api/series'
import { getUserList } from '@/api/user'
import { getPlayList } from '@/api/play'
import { getActivityPushRuleList } from '@/api/activityPush'
import { baseUrl } from '@/libs/api.request'
import { getToken } from '@/libs/util'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  components: {
    Pages,
    UploadFileImg,
    Editor,
    Toolbar
  },
  data() {
    return {
      editVisible: false,
      form: {
        channel: 0,
        pushMode: 2,
        states: false,
        pushTitle: '',
        emailTitle: '',
        triggerTime: '',
        triggerTypeCode: '',
        subscriptionTopicId: '',
        multiUserIds: '',
        crowdPackIds: [],
        pushMsg: '',
        fileUrl: '',
        fileId: '',
        jumpInterface: '',
        activityId: '',
        playName: '',
        playId: '',
        seriesId: '',
        emailBody: '',
        signTime: '',
      },
      crowdList: [],
      jumpInterfaceList: [],
      searchForm: {},
      submitLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        {
          title: '推送id',
          key: 'pushIdStr'
        },
        {
          title: '推送类型',
          key: 'channelName'
        },
        {
          title: '触发类型',
          key: 'triggerType'
        },
        {
          title: '语言',
          key: 'language'
        },
        {
          title: '推送短剧',
          key: 'playName'
        },
        {
          title: '推送人群',
          key: 'crowdPackNames'
        },
        {
          title: '触发时间',
          key: 'triggerTime'
        },
        {
          title: '状态',
          key: 'states',
          slot: 'state'
        },
        {
          title: '创建时间',
          key: 'createTime'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ],
      seriesList: [],
      playList: [],
      playListRaw: [],
      seriesList: [],
      topicLi: [],
      userList: [],
      userLoading: false,
      seriesLoading: false,
      editor: null,
      toolbarConfig: {
        excludeKeys: ['uploadVideo']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            server: baseUrl + '/file/upload',
            fieldName: 'file',
            headers: {
              token: getToken()
            },
            customInsert(res, insertFn) {
              if (res.code === 200 && res.data && res.data.fileUrl) {
                insertFn(res.data.fileUrl, res.data.fileName || 'image', res.data.fileUrl)
              }
            }
          },
          uploadVideo: {
            server: baseUrl + '/file/upload',
            fieldName: 'file',
            headers: {
              token: getToken()
            },
            customInsert(res, insertFn) {
              if (res.code === 200 && res.data && res.data.fileUrl) {
                insertFn(res.data.fileUrl, res.data.fileUrl)
              }
            }
          }
        }
      },
      mode: 'default'
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server/push')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    },
    filteredJumpInterfaceList() {
      return this.jumpInterfaceList.filter(item => item.status !== 0)
    }
  },
  watch: {
    'form.playId': {
      handler(o, n) {
        if (this.form.playId && o != n) {
          this.seriesLoading = true
          this.handleSelectSeries()
        }
      },
    }
  },
  
  methods: {
    onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
    getTopic() {
      getDictionaryList({
        current: -1,
        size: -1,
        dictTopic: 'SUBSCRIPTION_TOPIC'
      }).then(r => {
        this.topicLi = r.data.records
      })
    },
    
    getPlayList: debounce(async function(query) {
      if (!query || query.trim() === '') {
        this.playListRaw = []
        this.playList = []
        return
      }
      await getPlayList({
        current: -1,
        size: -1,
        keyword: this.form.playName || ''
      }).then(r => {
        this.playListRaw = r.data.records || []
        this.playList = this.playListRaw.map(item => item.playName)
      })
    }, 500),
    handleSelectPlay(value) {
      const matchedItem = this.playListRaw.find(item => item.playName === value)
      if (matchedItem) {
        this.form.playId = matchedItem.id
        this.form.playName = matchedItem.playName
        this.seriesList = []
        this.getSeriesList()
        this.$nextTick(() => {
          if (this.$refs.formRef && this.$refs.formRef.clearValidate) {
            this.$refs.formRef.clearValidate(['playName'])
          }
        })
      }
    },
    getSeriesList() { 
      getSeriesList({
        current: -1,
        size: -1, 
        playId:this.form.playId
      }).then(r => {
        this.seriesList = r.data.records
      })
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getPushList({
        ...this.page,
        ...this.searchForm,
        crowdPackIds: this.searchForm.crowdPackIds&&this.searchForm.crowdPackIds.length?this.searchForm.crowdPackIds.join(','):''
      }).then(({ data }) => {
        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    getjumpInterfaceList() {
      getActivityPushRuleList({
        current: 1,
        size: 10,
      }).then(r => {
        this.jumpInterfaceList = r.data.records
      })
    },
    handleJumpInterfaceChange(value) {
      const selectedItem = this.jumpInterfaceList.find(item => item.id === value)
      if (selectedItem) {
        this.form.activityId = selectedItem.id
      }
    },
    handleJumpPageChange(value) {
      if (value !== '1') {
        this.form.playName = ''
        this.form.playId = ''
        this.form.seriesId = ''
        this.playList = []
        this.playListRaw = []
        this.seriesList = []
      }
    },

     handleTriggerTimeChange(date) {
      this.form.triggerTime = date || '';
    },
    handleSelectSeries() {
      // this.seriesList = []
      getSeriesList({ playId: this.form.playId, current: -1, size: -1 }).then(r => {
        this.seriesList = r.data.records
        this.seriesLoading = false
      })
    },
    handleFindUser: debounce(function (query) {
      if (!query) {
        this.userList = []
        this.userLoading = false
      } else {
        this.userLoading = true
        getUserList({
          current: -1,
          userId: query,
          size: -1
        }).then(r => {
          this.userList = r.data.records
          this.userLoading = false
        })
      }
    }, 700),
    handleChangeStatus(row) {
      changePushStatus(row.id, { states: !row.states })
        .then((r) => {
          this.$Message.success('操作成功')
          this.getData(this.page.current)
        })
        .catch((e) => {
          this.$Message.error('操作失败')
        })
      return new Promise(() => { })
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getPushInfo(row.id)
        this.form = {
          ...r.data,
          multiUserIds: r.data.userIdList,
          userIdList: null,
          userIds: null
        }
        if (this.form.triggerTypeCode === 'activity') {
          // 尝试从 jumpInterfaceList 中匹配并设置 jumpInterface 和 activityId
          const matchedItem = this.jumpInterfaceList.find(item => item.id === this.form.activityId)
          if (matchedItem) {
            this.form.jumpInterface = matchedItem.id
            this.form.activityId = matchedItem.id
          } else if (this.form.jumpInterface === '/weekend' || this.form.jumpInterface === '/festival') {
            const fallbackItem = this.jumpInterfaceList.find(item =>
              (item.activityType === 1 ? '/weekend' : '/festival') === this.form.jumpInterface
            )
            if (fallbackItem) {
              this.form.jumpInterface = fallbackItem.id
              this.form.activityId = fallbackItem.id
            }
          }
        }
      } else {
        this.form = {
          channel: 0,
          pushMode: 2,
          states: false,
          pushTitle: '',
          emailTitle: '',
          triggerTime: '',
          triggerTypeCode: '',
          subscriptionTopicId: '',
          multiUserIds: '',
          crowdPackIds: [],
          pushMsg: '',
          fileUrl: '',
          fileId: '',
          jumpInterface: '',
          activityId: '',
          playName: '',
          playId: '',
          seriesId: '',
          emailBody: '',
          signTime: '',
        }
      }
      this.editVisible = true
    },
    handleChannelChange() { 
      this.form.triggerTypeCode = ''
      this.form.pushMode = this.form.channel === 0 ? 2 : 1
      this.form.subscriptionTopicId = ''
      this.form.multiUserIds = ''
      this.form.crowdPackIds = []
      this.form.pushTitle = ''
      this.form.pushMsg = ''
      this.form.fileUrl = ''
      this.form.jumpInterface = ''
      this.form.activityId = ''
      this.form.playName = ''
      this.form.playId = ''
      this.form.seriesId = ''
      this.playList = []
      this.seriesList = []
      this.form.triggerTime = ''
      this.form.emailTitle = ''
      this.form.emailBody = ''
      this.form.states = false
      this.$nextTick(() => {
        if (this.$refs.formRef && this.$refs.formRef.clearValidate) {
          this.$refs.formRef.clearValidate(['dramaPushTime','triggerTypeCode','pushTitle','emailTitle','triggerTime','pushMsg','jumpInterface'])
        }
      })
    },

    handlePushModeChange() {
      this.form.subscriptionTopicId = ''
      this.form.multiUserIds = ''
      this.form.crowdPackIds = []
      this.form.activityId = ''
      this.$nextTick(() => {
        if (this.$refs.formRef && this.$refs.formRef.clearValidate) {
          this.$refs.formRef.clearValidate(['pushMsg','jumpInterface','dramaPushTime','emailTitle','pushTitle','triggerTime'])
        }
      })
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      
      return `${hours}:${minutes}:${seconds}`;
    },
    handleTriggerTypeChange(value) {
      if (value === 'sign') {
        this.$set(this.form, 'signTime', this.formatDate(new Date()));
      } else {
        this.$set(this.form, 'signTime', '');
      }
      if (value !== 'activity') {
        this.$set(this.form, 'activityId', '');
      }
    },
    handleSignTimeChange(date) {
      this.$set(this.form, 'signTime', this.formatDate(date));
    },
    handleTriggerTimeRangeChange(dates) {
      // 处理日期范围选择器的数据
      if (dates && dates.length === 2) {
        // 将起始时间和结束时间分别存储
        this.$set(this.searchForm, 'beginTime', this.formatDateTime(dates[0]));
        this.$set(this.searchForm, 'endTime', this.formatDateTime(dates[1]));
      } else {
        // 清空时间范围
        this.$set(this.searchForm, 'beginTime', '');
        this.$set(this.searchForm, 'endTime', '');
      }
    },
    formatDateTime(date) {
      // 将日期格式转换为 yyyy-MM-dd HH:mm:ss
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async getCrowdList() {
      await getCrowdList({
        current: -1,
        size: -1,
        total: -1
      }).then((r) => {
        this.crowdList = r.data.records
      })
    },
    async handleSubmit() {
      if (this.form.pushMode === 0) {
        if (
          !this.form.crowdPackIds.length &&
          (!this.form.multiUserIds || this.form.multiUserIds.trim() === '')
        ) {
          this.$Message.error('请至少选择一个人群包或填写指定用户ID')
          return
        }
      }
      if (this.form.channel === 1) {
        const content = this.form.emailBody || ''
        const textContent = content.replace(/<[^>]*>/g, '').trim()
        const hasMedia = /<img|<video|<iframe/.test(content)
        if (!textContent && !hasMedia) {
          this.$Message.error('请输入邮件内容')
          return
        }
      }

      this.$refs.formRef.validate(r => {
        if (r) {
          const func = this.form.id ? editPush : addPush
          this.submitLoading = true
          const submitData = { ...this.form }
          if (submitData.triggerTypeCode === 'activity') {
            const matchedItem = this.jumpInterfaceList.find(item => item.id === submitData.jumpInterface)
            if (matchedItem) {
              submitData.jumpInterface = matchedItem.activityType === 1 ? '/weekend' : '/festival'
            }
          }
          func(submitData).then(r => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleDel(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定要删除这条推送消息吗？',
        onOk: () => {
          delPush(row.id).then(r => {
            this.$Message.success('删除成功')
            this.getData()
          })
        }
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
    this.getTopic()
    this.getCrowdList()
    this.getPlayList()
    this.getjumpInterfaceList()

    setTimeout(() => {
      this.form.emailBody = ''
    }, 1500)
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less">
.w-e-full-screen-container {
  z-index: 9999 !important;
}
</style>
<style scoped lang="less">
.search-form {
  display: flex;

  &>* {
    margin: 0 5px;
  }
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
